import { render, staticRenderFns } from "./CbrUpdatesItem.vue?vue&type=template&id=08ed05fe&scoped=true&lang=pug&"
import script from "./CbrUpdatesItem.vue?vue&type=script&lang=js&"
export * from "./CbrUpdatesItem.vue?vue&type=script&lang=js&"
import style0 from "./CbrUpdatesItem.vue?vue&type=style&index=0&id=08ed05fe&lang=scss&scoped=true&"
import style1 from "./CbrUpdatesItem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ed05fe",
  null
  
)

export default component.exports